import { createStore, Store } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";

import { rootReducer, StoreState } from "../reducers/root-reducer";

const composeEnhancers = composeWithDevTools();

export const store: Store<StoreState> = createStore(
	rootReducer,
	composeEnhancers
);
